import React, { useRef } from 'react';
import useSetState from '../../../hooks/useSetState';
import ShowForPermission from '../../../components/ShowForPermission';
import DatePicker from '../../../components/FormElements/DatePicker/DatePicker';
import ENUMS from '../../../enums';

const TakeawayFinancialReportsFilter = ({ data, pageNumber, pageSize, resetForm, getTakeawayList, applyFilters, hasRseeAdminPermission }) => {
  let formRefrence = useRef();

  const [controls, setControls] = useSetState({
    cafeNamePart: '',
    startDate: '',
    endDate: '',
  });

  const onChangeValue = (controleName, value) => {
    setControls({ [controleName]: value });
  };

  const onSubmit = event => {
    event.preventDefault();
    applyFilters(event, controls.cafeIds);
  };

  const onReset = () => {
    Array.from(formRefrence.current).forEach(element => {
      if (element.type === 'checkbox') {
        element.checked = null;
      }
    });
    onChangeValue('startDate', ' ');
    onChangeValue('endDate', ' ');
    onChangeValue('cafeNamePart', '');
    resetForm();
    getTakeawayList(pageNumber, pageSize)
  };

  return (
    <section>
      <form
        ref={formRefrence}
        onSubmit={event => onSubmit(event)}
        id="filterForm"
        className="card card my-4">

        <header className="text-center card-header">
          <h5 className="font-italic text-muted">{locales('titles.filter')}</h5>
        </header>

        <main className="card-body">
          <div className="d-flex row flex-sm-column col-12 flex-md-row justify-content-between px-1 mx-1">
            <div className={`d-flex ${hasRseeAdminPermission ? 'col-lg-4' : 'col-lg-6'} col-md-12 col-sm-12 align-items-center`}>
              <label className="rsee-form-label col-lg-5 text-right">
                {locales('fields.cafe.contract.start.date')}
              </label>
              <div className="full-width">
                <DatePicker
                  marge={true}
                  placeholder={locales('fields.startDate')}
                  name="startDate"
                  onChange={val => onChangeValue('startDate', val)}
                  value={controls.startDate}
                  className="date-picker-input"
                />
              </div>
            </div>
            <div className={`d-flex ${hasRseeAdminPermission ? 'col-lg-4' : 'col-lg-6'} col-md-12 col-sm-12 align-items-center`}>
              <label className="rsee-form-label col-lg-5 text-right">
                {locales('fields.cafe.contract.end.date')}
              </label>
              <div className="full-width">
                <DatePicker
                  marge={true}
                  placeholder={locales('fields.endDate')}
                  name="endDate"
                  onChange={val => onChangeValue('endDate', val)}
                  value={controls.endDate}
                  className="date-picker-input"
                />
              </div>
            </div>
            <div className={`d-flex ${hasRseeAdminPermission ? 'col-lg-4' : 'col-lg-6'} col-md-12 col-sm-12 align-items-center`}>
              <ShowForPermission
                permission={ENUMS.PERMISSIONS.values.AUTO_GENERATE_RESERVE_DATES_AND_HOURS_FOR_ALL_CAFES}>
                <label className="rsee-form-label text-right">
                  {locales('fields.cafe.name')}
                </label>
                <div className="full-width">
                  <input
                    className="form-control col-12"
                    type="text"
                    id="cafeNamePart"
                    name="cafeNamePart"
                    placeholder={locales('fields.cafe.name')}
                    maxLength={ENUMS.MAX_LENGTH.cafeName}
                    onChange={e => onChangeValue('cafeNamePart', e.target.value)}
                    value={controls.cafeNamePart}
                  />
                </div>
              </ShowForPermission>
            </div>
          </div>

          <div className="d-flex row flex-sm-column col-12 flex-md-row justify-content-start px-1 mx-1 mt-3">
            <div className={`d-flex ${hasRseeAdminPermission ? 'col-lg-6' : 'col-lg-8'} col-md-12 col-sm-12 align-items-center`}>
              <label className={`rsee-form-label ${hasRseeAdminPermission ? 'col-lg-3' : 'col-lg-5'} text-right`}>
                {locales('tables.payStatus')}
              </label>
              <div className="full-width d-flex justify-content-around mx-1 py-2">
                {ENUMS.TAKEAWAY_PAYMENT_STATUS.list.map((paymentStatus, index) => (
                  <div className={`col-6 d-flex justify-content-start align-items-center p-0`} key={index}>
                    <input
                      type="checkbox"
                      value={paymentStatus.value}
                      name="paymentStatus"
                      id={`paymentStatus-${index}`}
                      className=""
                      maxLength="10"
                    />
                    <label className="mx-1 text-center my-2 p-0" htmlFor={`paymentStatus-${index}`}>
                      {paymentStatus.title}
                    </label>
                  </div>
                ))}
              </div>
            </div>

            <div className={`${hasRseeAdminPermission ? 'd-flex col-lg-6' : 'd-none'} col-md-12 col-sm-12 align-items-center`}>
              <label className={`rsee-form-label ${hasRseeAdminPermission ? 'col-lg-4' : 'col-lg-5'} text-right`}>
                {locales('fields.cafe.status')}
              </label>
              <div className="full-width d-flex justify-content-around mx-1 py-2">
                {ENUMS.CAFE_STATUS.list.map((cafeStatus, index) => (
                  <div className={`col-6 d-flex justify-content-start align-items-center p-0`} key={index}>
                    <input
                      type="checkbox"
                      value={cafeStatus.value}
                      name="cafeStatus"
                      id={`cafeStatus-${index}`}
                      className=""
                      maxLength="10"
                    />
                    <label className="mx-1 text-center my-2 p-0" htmlFor={`cafeStatus-${index}`}>
                      {cafeStatus.title}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="col-12 d-flex justify-content-end p-0 my-3">
            <button type="button"
              onClick={onReset}
              className="btn btn-danger w-5 mx-2">
              {locales('fields.reset')}
            </button>
            <button type="submit" className="btn btn-success w-5 mx-2">
              {locales('fields.applyFilters')}
            </button>
          </div>

        </main>
      </form>
    </section >
  );
}

export default TakeawayFinancialReportsFilter;